import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, debounceTime } from 'rxjs';
import { DayModel } from '../../models/day-model';
import { RouteModel } from '../../models/route.model';

@Component({
  selector: 'routes-box-collapsed',
  standalone: false,
  templateUrl: './routes-box-collapsed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutesBoxCollapsedComponent implements OnChanges, OnInit {
  @Input() day!: DayModel;
  @Input() routes!: RouteModel[];

  @Output() collapsedCellClicked = new EventEmitter<DayModel>;

  StartAddress!: string;
  StartDate!: Date;
  EndAddress!: string;
  routesCount!: number;
  totalOrdersCount!: number;
  isDragOver = false;
  destroyRef = inject(DestroyRef);
  dragOnTheObjectDebounce$ = new BehaviorSubject<boolean>(false);


  ngOnInit(): void {
    this.dragOnTheObjectDebounce$.pipe(
      takeUntilDestroyed(this.destroyRef),
      debounceTime(550)
    ).subscribe(v => {
      if (v===true) {
        this.collapsedCellClicked.emit();
      }
    })
  }

  ngOnChanges(): void {
    if (this.routes && this.routes.length > 0) {
      this.totalOrdersCount = this.routes.flatMap(r => r.orders).length;
      this.routesCount = this.routes.length;

      this.StartDate = this.routes[0].orders[0].StartDate;
      this.StartAddress = this.routes[0].orders[0].StartAddress;

      // end adress of the last item in all routes
      this.EndAddress = this.routes[this.routes.length - 1].orders[this.routes[this.routes.length - 1].orders.length - 1].EndAddress;
    }
  }

  onDragEnter() {
    this.isDragOver = true;
    this.dragOnTheObjectDebounce$.next(true)
  }

  onDragLeave() {
    this.isDragOver = false;
    this.dragOnTheObjectDebounce$.next(false)
  }
}
